import React, { useState } from 'react';
import ButtonsGeneric from '../../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../../components/NovoSistema/ContainerSection';
import DoubleInput from '../../../../../../../../components/NovoSistema/DoubleInput';
import InputDate from '../../../../../../../../components/NovoSistema/InputDate';
import InputCheckBox from '../../../../../../../../components/NovoSistema/InputCheckBox';
import SelectAndOptions from '../../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import ButtonOptions from '../../../../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../../../../components/NovoSistema/HeaderButtons';
import InputText from '../../../../../../../../components/NovoSistema/InputText';

export default function EntradaFilter() {
  const [option, setOption] = useState('Filtro');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Filtro"
          border="#DFB007"
          active={option === 'Filtro' ? true : false}
          yourFunction={() => setOption('Filtro')}
        />
        <ButtonOptions
          buttonName="Campos"
          border="#DFB007"
          active={option === 'Campos' ? true : false}
          yourFunction={() => setOption('Campos')}
        />
      </HeaderButtons>
      {option === 'Filtro' && (
        <ContainerSection>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Emitida por"
              id="EmitidaPor"
              optionsArray={['', 'Matriz/Filial', 'Terceiros']}
              widthPercentage="20%"
            />
            <InputText title="Nº Docto" id="NDocto" widthPercentage="20%" />
            <SelectAndOptions
              title="Documento Fiscal"
              id="DocumentoFiscal"
              optionsArray={[
                '',
                '1  | NF    | Nota Fiscal',
                '1B | NFA   | Nota Fiscal Avulsa',
                '2  | NFVC  | Nota Fiscal Venda Consumidor',
                '2D | CFECF | Cupom Fiscal - ECF',
                '4  | NFP   | Nota Fiscal Produtor',
                '55 | NFE   | Nota Fiscal Eletrônica',
                '59 | CFE   | Cupom Fiscal Eletrônico - SAT',
                '65 | NFCE  | Nota Fiscal Eletrônica ao Consumidor Final - NFC-e',
              ]}
              widthPercentage="20%"
            />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <DoubleInput title="Parceiro de Negócios/Empresa" id="ParceiroDeNegociosEmpresas" widthPercentage="40%" />
            <SelectAndOptions
              title="Tipo de Pessoa"
              id="TipoDePessoa"
              optionsArray={['', 'Física', 'Jurídica']}
              widthPercentage="20%"
            />
            <InputText title="CNPJ/CPF" id="CNPJCPF" widthPercentage="20%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputDate title="Entrada Inicial" id="EntradaInicial" widthPercentage="20%" />
            <InputDate title="Entrada Final" id="EntradaFinal" widthPercentage="20%" />
            <InputDate title="Emissão Inicial" id="EmissaoInicial" widthPercentage="20%" />
            <InputDate title="Emissão Final" id="EmissaoFinal" widthPercentage="20%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <DoubleInput title="Produto" id="Produto" widthPercentage="40%" />
            <SelectAndOptions
              title="Tipo Relatório"
              id="TipoRelatorio"
              optionsArray={['Analítico', 'Sintético']}
              widthPercentage="20%"
            />
            <SelectAndOptions
              title="Ordenar por"
              id="OrdenarPor"
              optionsArray={['Data Entrada', 'Nº Nota Fiscal', 'Parceiro de Negócio']}
              widthPercentage="20%"
            />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputCheckBox title="Exibir notas não importadas" id="ExibirNotasNaoImportadas" />
          </WrapperInputsNewSystem>
          <ButtonsGeneric>
            <button className="normal">Limpar</button>
          </ButtonsGeneric>
        </ContainerSection>
      )}
      {option === 'Campos' && (
        <ContainerSection>
          <p>Ao selecionar algum campo disponível o relatório será gerado apenas em excel.</p>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Disponíveis"
              id="Disponíveis"
              optionsArray={[
                'ICMS',
                'PIS',
                'COFINS',
                'Data Emissão',
                'Data Entrada',
                'Chave de Acesso',
                'Base de Cálculo ICMS',
              ]}
              widthPercentage="30%"
            />
            <ButtonsGeneric>
              <button className="success">Adicionar</button>
              <button className="error">Remover</button>
            </ButtonsGeneric>
            <SelectAndOptions title="Selecionados" id="Selecionados" optionsArray={['']} widthPercentage="30%" />
          </WrapperInputsNewSystem>
        </ContainerSection>
      )}
    </div>
  );
}
